<template>
  <div class="fdd-add-sign-title">
    <a @click="handleBack"> <i class="use-return"></i>{{ title }}</a>
    <span v-if="content">{{ content }}</span>
  </div>
</template>
<script>
  import { goBack } from '@/utils'

  export default {
    name: 'FddPageHeader',
    props: {
      content: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: '返回上级'
      },
      closeTab: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleBack() {
        if (Object.hasOwnProperty.call(this.$listeners, 'back')) {
          this.$emit('back')
        } else {
          this.goBack(this.closeTab)
        }
      },
      goBack
    }
  }
</script>
